import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Sidebar from './Components/Sidebar';

const Login = lazy(() => import('./Pages/Login/Login'));
const Dashboard = lazy(() => import('./Pages/Dashboard/Dashboard'));
const Products = lazy(() => import('./Pages/Products/Products'));
const Orders = lazy(() => import('./Pages/Orders/Orders'));
const Users = lazy(() => import('./Pages/Users/Users'));
const Discounts = lazy(() => import('./Pages/Discounts/Discounts'));
const Categories = lazy(() => import('./Pages/Categories/Categories'));
const Tickets = lazy(() => import('./Pages/Tickets/Tickets'));
const Checkouts = lazy(() => import('./Pages/Checkouts/Checkouts'));
const Uploads = lazy(() => import('./Pages/Uploads/Uploads'));
const UserDetail = lazy(() => import('./Pages/Users/UserDetail'));
const UserEdit = lazy(() => import('./Pages/Users/UserEdit'));
const OrderDetails = lazy(() => import('./Pages/OrderDetails/OrderDetails'));

function AdminLayout({ children }) {
  return (
    <div className="admin-layout">
      <Sidebar />
      <div className="admin-content">
        {children}
      </div>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const token = sessionStorage.getItem('token');
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function PublicRoute({ children }) {
  const token = sessionStorage.getItem('token');
  if (token) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

function App() {
  return (
    <BrowserRouter>
    <ToastContainer />
      <Suspense fallback={<div className="route-loading"><span className="loader" />Loading page...</div>}>
      <Routes>
        <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="/dashboard" element={<ProtectedRoute><AdminLayout><Dashboard /></AdminLayout></ProtectedRoute>} />
        <Route path="/products" element={<ProtectedRoute><AdminLayout><Products /></AdminLayout></ProtectedRoute>} />
        <Route path="/products/new" element={<ProtectedRoute><AdminLayout><Products mode="create" /></AdminLayout></ProtectedRoute>} />
        <Route path="/products/:id/edit" element={<ProtectedRoute><AdminLayout><Products mode="edit" /></AdminLayout></ProtectedRoute>} />
        <Route path="/orders" element={<ProtectedRoute><AdminLayout><Orders /></AdminLayout></ProtectedRoute>} />
        <Route path="/users" element={<ProtectedRoute><AdminLayout><Users /></AdminLayout></ProtectedRoute>} />
        <Route path="/users/:id" element={<ProtectedRoute><AdminLayout><UserDetail /></AdminLayout></ProtectedRoute>} />
        <Route path="/users/:id/edit" element={<ProtectedRoute><AdminLayout><UserEdit /></AdminLayout></ProtectedRoute>} />
        <Route path="/orders/:id" element={<ProtectedRoute><AdminLayout><OrderDetails /></AdminLayout></ProtectedRoute>} />
        <Route path="/discounts" element={<ProtectedRoute><AdminLayout><Discounts /></AdminLayout></ProtectedRoute>} />
        <Route path="/categories" element={<ProtectedRoute><AdminLayout><Categories /></AdminLayout></ProtectedRoute>} />
        <Route path="/categories/new" element={<ProtectedRoute><AdminLayout><Categories /></AdminLayout></ProtectedRoute>} />
        <Route path="/categories/:id/edit" element={<ProtectedRoute><AdminLayout><Categories /></AdminLayout></ProtectedRoute>} />
        <Route path="/tickets" element={<ProtectedRoute><AdminLayout><Tickets /></AdminLayout></ProtectedRoute>} />
        <Route path="/checkouts" element={<ProtectedRoute><AdminLayout><Checkouts /></AdminLayout></ProtectedRoute>} />
        <Route path="/uploads" element={<ProtectedRoute><AdminLayout><Uploads /></AdminLayout></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
